import React, { useMemo, useState } from "react"
import CoffeeOrderingApp from "../components/CoffeeOrderingApp"
import "./RugasApp.css"

export default function RugasApp() {
  const EXPECTED_PHRASE = useMemo(() => (process.env.REACT_APP_RUGAS_APP_PHRASE || "").trim(), [])
  const [phrase, setPhrase] = useState("")
  const [unlocked, setUnlocked] = useState(false)
  const [showError, setShowError] = useState(false)

  const onSubmit = (e) => {
    e.preventDefault()
    setShowError(false)

    if (!EXPECTED_PHRASE) {
      setUnlocked(true)
      return
    }

    const ok = phrase.trim() === EXPECTED_PHRASE
    setUnlocked(ok)
    setShowError(!ok)
  }

  if (unlocked) return <CoffeeOrderingApp />

  return (
    <div className="rugas-gate">
      <div className="rugas-gate-card">
        <h1 className="rugas-gate-title">Ruga&apos;s Coffee App</h1>
        <p className="rugas-gate-subtitle">Enter the test phrase to continue.</p>

        <form onSubmit={onSubmit} className="rugas-gate-form">
          <label className="rugas-gate-label" htmlFor="phrase">
            Test phrase
          </label>

          <input
            id="phrase"
            type="password"
            value={phrase}
            onChange={(e) => setPhrase(e.target.value)}
            className="rugas-gate-input"
            placeholder="Enter phrase"
            autoFocus
          />

          <button type="submit" className="rugas-gate-button">
            Unlock
          </button>

          {showError ? <p className="rugas-gate-error">Incorrect phrase.</p> : null}

          {!EXPECTED_PHRASE ? (
            <div className="rugas-gate-note">
              Missing REACT_APP_RUGAS_APP_PHRASE. Access is currently unlocked.
            </div>
          ) : null}
        </form>
      </div>
    </div>
  )
}
